module.exports = "<p>\n  my-details works!\n</p>\n"